/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Type_PhotoInputs */

const en_media_type_photo = /** @type {(inputs: Media_Type_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo`)
};

const id_media_type_photo = /** @type {(inputs: Media_Type_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto`)
};

/** @type {(inputs: Media_Type_PhotoInputs) => LocalizedString} */
const es_media_type_photo = en_media_type_photo;

/** @type {(inputs: Media_Type_PhotoInputs) => LocalizedString} */
const fr_media_type_photo = en_media_type_photo;

/** @type {(inputs: Media_Type_PhotoInputs) => LocalizedString} */
const de_media_type_photo = en_media_type_photo;

/** @type {(inputs: Media_Type_PhotoInputs) => LocalizedString} */
const ja_media_type_photo = en_media_type_photo;

/** @type {(inputs: Media_Type_PhotoInputs) => LocalizedString} */
const zh_media_type_photo = en_media_type_photo;

/** @type {(inputs: Media_Type_PhotoInputs) => LocalizedString} */
const ar_media_type_photo = en_media_type_photo;

/** @type {(inputs: Media_Type_PhotoInputs) => LocalizedString} */
const it_media_type_photo = en_media_type_photo;

/** @type {(inputs: Media_Type_PhotoInputs) => LocalizedString} */
const ru_media_type_photo = en_media_type_photo;

/** @type {(inputs: Media_Type_PhotoInputs) => LocalizedString} */
const pt_media_type_photo = en_media_type_photo;

/** @type {(inputs: Media_Type_PhotoInputs) => LocalizedString} */
const ko_media_type_photo = en_media_type_photo;

/**
* | output |
* | --- |
* | "Photo" |
*
* @param {Media_Type_PhotoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const media_type_photo = /** @type {((inputs?: Media_Type_PhotoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Type_PhotoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_media_type_photo(inputs)
	if (locale === "es") return es_media_type_photo(inputs)
	if (locale === "fr") return fr_media_type_photo(inputs)
	if (locale === "de") return de_media_type_photo(inputs)
	if (locale === "ja") return ja_media_type_photo(inputs)
	if (locale === "zh") return zh_media_type_photo(inputs)
	if (locale === "ar") return ar_media_type_photo(inputs)
	if (locale === "id") return id_media_type_photo(inputs)
	if (locale === "it") return it_media_type_photo(inputs)
	if (locale === "ru") return ru_media_type_photo(inputs)
	if (locale === "pt") return pt_media_type_photo(inputs)
	return ko_media_type_photo(inputs)
});